import React from 'react';
import InventarioFilter from './filterInventario';
import ButtonOptions from '../../../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../../../components/NovoSistema/HeaderButtons';

export default function Inventario() {
  return (
    <main>
      <HeaderButtons>
        <ButtonOptions buttonName="Imprimir" border="#333F50" />
        <ButtonOptions buttonName="Exportar" border="#333F50" />
      </HeaderButtons>
      <InventarioFilter />
    </main>
  );
}
